import { createRouter, createWebHistory } from 'vue-router'

import Login from '@/pages/login/routes'
import Dashboard from '@/pages/dashboard/routes'
import SolvaAi from '@/pages/solva-ai/routes'
import Profile from '@/pages/profile/routes'
import Brand from '@/pages/brand/routes'
import Outlet from '@/pages/outlet/routes'
import HybridOutlet from '@/pages/hybrid-outlet/routes'
import Library from '@/pages/library/routes'
import Loyalty from '@/pages/loyalty/routes'
import Member from '@/pages/member/routes'
import Tier from '@/pages/tier/routes'
import Benefit from '@/pages/benefit/routes'
import VoucherSelling from '@/pages/voucher-selling/routes'
import CRM from '@/pages/crm/routes'
import AppContent from '@/pages/app-content/routes'
import Report from '@/pages/report/routes'
import OutletApp from '@/pages/outlet-app/routes'
import Admin from '@/pages/admin/routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/app',
      component: () => import('@/components/layouts/MainLayout.vue'),
      children: [
        ...Profile,
        Dashboard,
        SolvaAi,
        ...Brand,
        ...Outlet,
        ...HybridOutlet,
        Library,
        Loyalty,
        ...Member,
        ...Tier,
        ...Benefit,
        VoucherSelling,
        CRM,
        AppContent,
        Report,
        OutletApp,
        Admin
      ],
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/auth',
      component: () => import('@/components/layouts/AuthLayout.vue'),
      children: [...Login],
      meta: {
        requiresAuth: false
      }
    },
    { path: '/:pathMatch(.*)*', redirect: '/app/member' }
  ]
})

router.beforeEach((to) => {
  const isAuthenticated = !!tokenService.getTokenFromLocalStorage()

  document.title = to.meta.title
    ? `${to.meta.title} | Solva FnB CMS`
    : 'Solva FnB CMS'

  if (to.meta.requiresAuth && !isAuthenticated) {
    return {
      name: 'login',
      query: {
        redirect: to.fullPath
      }
    }
  }

  if (to.name === 'login' && isAuthenticated) {
    return {
      name: 'dashboard'
    }
  }

  return true
})

export default router
